import type { ReactNode } from 'react';

import type { FeatureFlagInput } from './enums/feature-flags';
import { useFeatureFlag } from './hooks/useFeatureFlag';

interface Props {
  flag: FeatureFlagInput;
  children: ReactNode;
  fallback?: ReactNode;
}

const FeatureFlag = ({ flag, children, fallback = null }: Props) => {
  const value = useFeatureFlag(flag);

  return value ? <>{children}</> : <>{fallback}</>;
};

export default FeatureFlag;
